// DOCUMENTATION:
// https://reactrouter.com/docs/en/v6

// This file sets up the page navigation or the sitemap of our website.
// This is not our Navbar component

import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

// Import the necessary page files from ../pages/Something.js
import IndexPage from "../pages/IndexPage";
import ErrorPage from "../pages/ErrorPage";
import ContactPage from "../pages/ContactPage";
import ProductsPage from "../pages/ProductsPage";
import DealerPage from "../pages/DealerPage";
import MobileShowroomPage from "../pages/MobileShowroomPage";
import ProductDetailPage from "../pages/ProductDetailPage";
import Landing1Page from "../pages/Landing1Page";
import Landing2Page from "../pages/Landing2Page";

function Navigation(props) {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<IndexPage />} />
          <Route path="/dealers" element={<DealerPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mobile-showroom" element={<MobileShowroomPage />} />
          {/* Marketing Pages */}
          <Route path="/landing-1" element={<Landing1Page />} />
          <Route path="/landing-2" element={<Landing2Page />} />
          <Route path="/free-quote" element={<Landing1Page />} />
          <Route path="/learn-more" element={<Landing2Page />} />

          {/* Other */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
}

export default Navigation;
